<template>
  <div id="app">
    <router-view />
    <alert />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/layout/_alert.vue";
export default {
  components: {
    Alert,
  },
  metaInfo() {
    return {
      title: "AR Cards",
    };
  },
  watch: {
    theme() {
      let htmlElement = document.documentElement;
      htmlElement.setAttribute("theme", this.theme);
    },
  },
  computed: {
    ...mapGetters(["theme"]),
  },
  methods: {
    ...mapActions(["toggleTheme"]),
  },
  mounted() {
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", "light");
    }
    this.toggleTheme(localStorage.getItem("theme"));
    let htmlElement = document.documentElement;
    htmlElement.setAttribute("theme", this.theme);
  },
};
</script>
